import React from 'react'
import styled from 'styled-components'

import background from '../../resources/img/qadra-background.jpg';

type Props = {
    children: any
}

export default function Container(props: Props) {
    return (
        <Wrapper>
            {props.children}
        </Wrapper>
    )
}

const Wrapper = styled.div`
    background-image: url(${background});
    background-size: cover;
    min-height: 100vh;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`